<template>
  <iframe id="svgFrame" frameborder="0" width="100%" height="100%" :src="svgUrl"></iframe>
</template>

<script>
export default {
  name: "DrawDisplay",
  props: ['svgUrl', 'idList', 'drawId'],
  data() {
    return {
      iframe: null,
      refreshTimer: null
    }
  },
  mounted () {
    var _this = this
    _this.iframe = document.querySelector('#svgFrame')
    // 处理兼容行问题
    if (_this.iframe.attachEvent) {
      _this.iframe.attachEvent('onload', function () {
        // iframe加载完毕以后执行操作
        console.log('iframe已加载完毕')
      })
    } else {
      _this.iframe.onload = function () {
      // iframe加载完毕以后执行操作
        console.log('iframe已加载完毕')
        _this.doQuery()
        _this.refreshTimer = setInterval(_this.doQuery, 1 * 60 * 1000);
      }
    }
  },
  destroyed() {
    clearInterval(this.refreshTimer);
  },
  methods: {
    doQuery() {
      let param = {id: this.idList, drawId: this.drawId}
      this.$api.energyDisplay.getDrawData(param).then(res => {
        if (res.code !== 500) {
          Object.keys(res.data).forEach(eData => {
            let graphPanel = this.iframe.contentWindow.document.getElementById(eData);
            let param = eData.split('_')[1];
            if(param === '4') {
              graphPanel.firstChild.nodeValue = res.data[eData] + " A";
            } else if(param === '5') {
              graphPanel.firstChild.nodeValue = res.data[eData] + " A";
            } else if(param === '6') {
              graphPanel.firstChild.nodeValue = res.data[eData] + " A";
            } else if(param === '1') {
              graphPanel.firstChild.nodeValue = res.data[eData] + " V";
            } else if(param === '2') {
              graphPanel.firstChild.nodeValue = res.data[eData] + " V";
            } else if(param === '3') {
              graphPanel.firstChild.nodeValue = res.data[eData] + " V";
            } else if (param === '-1') {
              graphPanel.setAttribute('fill', res.data[eData]);
            }
          })
        }
      });
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/EnergyMonitor/DrawDisplay.vue